import { deprecated, createAsyncAction } from 'typesafe-actions';

const { createAction } = deprecated;

export const GO_TO_RESULT = 'tabMenu/GO_TO_RESULT' as const;
export const GO_TO_AI = 'tabMenu/GO_TO_AI' as const;
export const GO_TO_IMAGE = 'tabMenu/GO_TO_IMAGE' as const;
export const GO_TO_SIMILAR_IMAGE = 'tabMenu/GO_TO_SIMILAR_IMAGE' as const;

export const SET_MENU_ID = 'tabMenu/SET_MENU_ID' as const;

export const goToResult = (q: string | string[]) => ({
  type: GO_TO_RESULT,
  query: q,
});
export const goToAI = (q: string | string[]) => ({ type: GO_TO_AI, query: q });
export const goToImage = (q: string | string[]) => ({
  type: GO_TO_IMAGE,
  query: q,
});
export const goToSimilarImage = (q: string | string[]) => ({
  type: GO_TO_SIMILAR_IMAGE,
  query: q,
});

export const setMenuID = createAction(
  SET_MENU_ID,
  (action) => (selectedMenuId: number) => action(selectedMenuId)
);
